var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUrgencyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 102,
    viewBox: "0 0 118 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_4301)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_21_4301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.5338 52.6533L42.5813 52.9548C41.1265 45.7934 36.2382 27.0031 40.6405 21.8778C40.8412 19.9488 41.7782 18.1715 43.2565 16.9159C44.7347 15.6603 46.6404 15.0231 48.5767 15.137C53.3742 7.62838 61.365 8.75574 66.7658 13.4452C72.2012 15.3204 74.2505 18.6519 73.5339 23.1729C77.5592 26.6959 78.3018 30.9821 76.4949 35.8612L73.5338 52.6533Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5539 71.7185L48.2225 68.6269L43.7562 62.1002C49.9086 58.0197 52.0857 52.3204 49.2532 44.5811L64.7134 44.2375C63.989 51.1296 66.2684 56.4659 72.6152 59.6956L70.5539 71.7185Z",
    fill: "#FFC2A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8447 50.0771C66.3831 50.0771 73.3049 43.1563 73.3049 34.619C73.3049 26.0818 66.3831 19.161 57.8447 19.161C49.3063 19.161 42.3845 26.0818 42.3845 34.619C42.3845 43.1563 49.3063 50.0771 57.8447 50.0771Z",
    fill: "#FFC2A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.71429 120.84L47.5366 136.298L56.2162 138.851C56.6045 138.965 57.0118 139 57.4137 138.952C57.8156 138.905 58.2038 138.777 58.555 138.576C58.9063 138.375 59.2132 138.105 59.4574 137.783C59.7017 137.46 59.8782 137.091 59.9763 136.699C60.1484 136.011 60.0712 135.284 59.7583 134.647C59.4454 134.01 58.917 133.505 58.2669 133.22L49.2543 130.459L22.1131 114.657L27.7819 99.7145L15.929 93.3595L8.71429 120.84Z",
    fill: "#FFC2A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.037 117.983L72.1978 131.455L69.6449 132.471C69.5635 132.503 69.4822 132.53 69.3964 132.557L60.8429 135.074C59.7494 135.395 58.2358 133.922 57.3501 132.905C56.9116 132.415 56.6632 131.785 56.65 131.127C56.6367 130.47 56.8595 129.83 57.2778 129.323C57.396 129.186 57.5261 129.061 57.6664 128.948C57.9961 128.691 58.3842 128.52 58.7961 128.451L67.3405 126.77C67.647 126.71 67.9416 126.6 68.2126 126.445L72.1979 124.123L92.8879 112.078C93.4633 111.744 93.9013 111.216 94.1239 110.589C94.3465 109.961 94.3392 109.276 94.1034 108.653L90.1542 98.2398C89.9121 97.6026 89.9101 96.8991 90.1487 96.2606C90.3874 95.6221 90.8503 95.0923 91.451 94.7701L97.9938 91.2642C98.3676 91.0636 98.7822 90.9503 99.2061 90.9331C99.6301 90.9158 100.052 90.995 100.441 91.1646C100.83 91.3343 101.176 91.59 101.451 91.9124C101.727 92.2349 101.926 92.6157 102.033 93.0262L107.713 114.658C107.888 115.321 107.814 116.025 107.505 116.638C107.196 117.25 106.674 117.729 106.037 117.983Z",
    fill: "#FFC2A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2678 32.1137C68.993 30.4972 62.8237 30.2752 56.8266 32.3257C53.0065 34.1756 48.4188 34.0052 43.3168 32.4809V17.0584L70.8607 17.7928L75.2678 32.1137Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4212 157.253L25.8933 157.94C35.1728 122.619 40.7236 89.8088 31.0467 67.2527L46.5069 59.6955C53.9614 67.4697 62.2634 66.6682 71.2432 59.0085L86.0163 62.7871C83.486 92.3659 84.6201 124.045 88.4212 157.253Z",
    fill: "#E5B800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.05896 92.6726C16.4453 95.5538 22.3201 100.471 26.9241 107.1L41.3536 86.1459L31.0467 67.2527L9.05896 92.6726Z",
    fill: "#E5B800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.004 88.8939C100.618 91.7751 94.743 96.6923 90.1391 103.321L75.7095 82.3671L86.0163 62.7871L108.004 88.8939Z",
    fill: "#E5B800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1332 48.3773C61.3698 51.1902 54.2781 51.076 46.8964 48.3773C49.0443 44.7116 45.8336 41.8405 44.1853 38.14L71.748 37.321C69.6402 40.5358 66.53 44.3339 68.1332 48.3773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4548 37.9327L71.1349 37.6133L71.5867 37.1615L74.286 34.0117L74.6295 34.3053L71.9184 37.4678L71.4548 37.9327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2948 36.0181L42.0054 36.3653L44.7165 38.6242L45.0059 38.277L42.2948 36.0181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2323 40.5888L67.4868 48.0424L67.8681 48.2851L72.6136 40.8314L72.2323 40.5888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7916 40.5882L42.4103 40.8308L47.1547 48.2853L47.536 48.0427L42.7916 40.5882Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2331 94.2894H75.6003C75.6003 71.1984 70.8452 55.1067 66.2114 55.1067L65.8032 53.4741C69.9589 53.4741 72.6083 60.1713 74.099 65.7898C76.1201 73.4066 77.2331 83.5279 77.2331 94.2894Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6782 88.5751H38.0454C38.0454 67.4275 42.8333 54.2902 49.8835 54.2902L49.4753 55.9228C44.5987 55.9228 39.6782 66.0192 39.6782 88.5751Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4146 98.779C78.6691 98.779 80.4967 96.9516 80.4967 94.6975C80.4967 92.4433 78.6691 90.6159 76.4146 90.6159C74.1601 90.6159 72.3325 92.4433 72.3325 94.6975C72.3325 96.9516 74.1601 98.779 76.4146 98.779Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1454 98.3706H31.5126C31.5126 92.5191 34.8088 87.7586 38.8604 87.7586V89.3912C35.7091 89.3912 33.1454 93.4193 33.1454 98.3706Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2083 98.3706H44.5754C44.5754 93.4193 42.0118 89.3912 38.8605 89.3912V87.7586C42.9121 87.7586 46.2083 92.5191 46.2083 98.3706Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3908 100.412C46.2926 100.412 47.0236 99.6806 47.0236 98.7789C47.0236 97.8773 46.2926 97.1463 45.3908 97.1463C44.489 97.1463 43.7579 97.8773 43.7579 98.7789C43.7579 99.6806 44.489 100.412 45.3908 100.412Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3287 100.412C33.2305 100.412 33.9615 99.6806 33.9615 98.7789C33.9615 97.8773 33.2305 97.1463 32.3287 97.1463C31.4269 97.1463 30.6959 97.8773 30.6959 98.7789C30.6959 99.6806 31.4269 100.412 32.3287 100.412Z",
    fill: "#3F3D56"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_21_4301",
    x: -1.28571,
    y: -0.285645,
    width: 119.29,
    height: 168.225,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_21_4301"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_21_4301",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_4301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 102,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrgencyIcon);
export default __webpack_public_path__ + "static/media/urgencyIcon.64ffdf0884dd93911f039a2869d203d0.svg";
export { ForwardRef as ReactComponent };